import { queryOptions, useQuery } from "@tanstack/react-query";

import { plantAjax } from "../../ajax/PlantAjax";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";

// Note: a failed fetch throws rather than returning [], so offline it cannot replace the list the prefetch cached.
export const plantJobTypesQuery = queryOptions({
  queryKey: ['references', 'plantJobTypes'],
  queryFn: async () => {
    const res = await plantAjax.getPlantJobTypes();
    if (ErrorResponse.isErrorResponse(res)) throw new Error('Failed to load plant job types');
    return res.data;
  },
  staleTime: 5 * 60 * 1000,
});

export function usePlantJobTypes() {
  const { data } = useQuery(plantJobTypesQuery);

  return data ?? [];
}
